import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TooltipConfig, TooltipModule } from 'ngx-bootstrap/tooltip';
import { MarkdownModule, WidgetsModule } from 'ngx-widgets';

import { SafePipeModule } from '../../pipes/safe.module';
import { CommentComponent } from './comment.component';

import { UserAvatarModule } from './../../widgets/user-avatar/user-avatar.module';


export class CommentModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [ CommentComponent],
  imports: [
    CommonModule,
    SafePipeModule,
    MarkdownModule,
    TooltipModule,
    WidgetsModule,
    UserAvatarModule
  ],
  exports: [CommentComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
